import type { AppStore } from "@/store/store";
import { selectIsSavingHierarchyChanges } from "./data-preparation-ui-selectors";

/**
 * Waits for an in-progress hierarchy save to finish before leaving the page.
 *
 * @param store The application store that owns the hierarchy save state.
 * @returns A promise that resolves when no hierarchy save is in progress.
 */
export function waitForHierarchySaveToFinish(store: AppStore): Promise<void> {
  if (!selectIsSavingHierarchyChanges(store.getState())) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const unsubscribe = store.subscribe(() => {
      if (!selectIsSavingHierarchyChanges(store.getState())) {
        unsubscribe();
        resolve();
      }
    });
  });
}
